module.exports = __webpack_public_path__ + "static/media/video.c8a0e0c2.png";